<template>
    <div class="form-page list-bookings">
        <div class="row">
            <div class="d-none d-lg-inline col-sm-8">
                <h2>Bookings</h2>
            </div>
            <div class="col-12 col-lg-4 text-right">
                <span class="text-note">(imported from 3 February 2023)</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 list-bookings__pills-and-add">
                <ul class="pills">
                    <li class="pills__pill" v-on:click="listAll()" v-bind:class="{'pills__pill--active': isListAllBookings}">
                        <span>All</span>
                    </li>
                    <li class="pills__pill" v-on:click="listFuture()" v-bind:class="{'pills__pill--active': isListFutureBookings}">
                        <span>Future</span>
                    </li>
                </ul>
                <div v-if="!isPMSEstablishment" ref="addTask" class="text-center list-bookings__add-task">
                    <button v-on:click.stop="addBooking" class="btn btn-primary">+ Add <span class="d-none d-sm-inline">Booking</span></button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 filter__cancelled-toggle" v-bind:class="{'filter__cancelled-toggle--on' : showCancelledBookings}">
                <span>Show cancelled bookings</span>
                <i v-if="showCancelledBookings" v-on:click="toggleShowCancelledBookings(false)" class="fas fa-toggle-on"></i>
                <i v-if="!showCancelledBookings" v-on:click="toggleShowCancelledBookings(true)" class="fas fa-toggle-off"></i>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <table class="tabular">
                    <thead>
                        <th class="head-in">
                            <span class="d-inline d-sm-none">
                                <i class="fas fa-walking"></i>
                                <i class="fas fa-door-open fa-flip-horizontal"></i>
                            </span>
                            <span class="d-none d-sm-inline">Check In</span>
                        </th>
                        <th class="head-out">
                            <span class="d-inline d-sm-none">
                                <i class="fas fa-door-open"></i>
                                <i class="fas fa-walking"></i>
                            </span>
                            <span class="d-none d-sm-inline">Check Out</span>
                        </th>
                        <th class="head-guest">
                            <span class="d-inline d-sm-none"><i class="fas fa-user"></i></span>
                            <span class="d-none d-sm-inline">Guest</span>
                        </th>
                        <th class="head-in d-none d-sm-table-cell">
                            Made
                        </th>
                        <th class="head-state"></th>
                    </thead>
                    <template v-if="bookings">
                        <booking-summary v-for="(booking, index) in bookingsToShow" v-bind:key="index" v-bind:booking="booking">
                        </booking-summary>
                    </template>
                </table>
                <div v-show="loading">
                    <Spinner/>
                </div>
                <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
                    {{infoMessage}}
                </div>
                <div v-show="!loading">
                    <div v-if="!hasBookings" class="text-center">-- No bookings --</div>
                    <div v-if="canLoadMoreBookings" class="load-more">
                        <template v-if="isListFutureBookings">Bookings with arrival until {{to}}</template>
                        <br/>
                        <button class="btn btn-secondary center" v-on:click="moreBookings">More</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showEditBooking">
            <EditBooking v-bind:booking="this.trip"></EditBooking>
        </div>
        <div v-if="showTripDetails">
            <TripDetails v-bind:booking="this.trip"></TripDetails>
        </div>

        <compare-booking v-if="showCompareBookingDialog"
                         v-bind:localBooking="localBooking"
                         v-bind:remoteBooking="remoteBooking"/>

        <confirm-dialog v-if="showConfirmDeleteDialog"
                        v-bind:message="confirmDeleteMessage"
                        v-bind:callbackPrimaryName="'delete-booking'"
                        v-bind:callbackPrimaryReference="trip.reference"/>
        <confirm-dialog v-if="showConfirmMigrateDialog"
                        v-bind:message="confirmMigrateMessage"
                        v-bind:callbackPrimaryName="'migrate-booking'"
                        v-bind:callbackPrimaryReference="trip.reference"/>
        <confirm-dialog v-if="showConfirmAcceptOrRejectChangesDialog"
                        v-bind:message="confirmAmendMessage"
                        v-bind:callbackPrimaryName="'manually-update-booking'"
                        v-bind:callbackPrimaryReference="trip.reference"
                        v-bind:continuePrimaryText="'Accept'"
                        v-bind:callbackSecondaryName="'reject-booking-changes'"
                        v-bind:callbackSecondaryReference="trip.reference"
                        v-bind:continueSecondaryText="'Reject'"/>
        <confirm-dialog v-if="showConfirmManuallyUpdateDialog"
                        v-bind:message="confirmManuallyUpdateMessage"
                        v-bind:callbackPrimaryName="'review-booking'"
                        v-bind:callbackPrimaryReference="trip.reference"
                        v-bind:continuePrimaryText="'Review and Merge'"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { store, getters } from '../store.js'
    import * as dayjs from 'dayjs'

    import Spinner from '../components/Spinner.vue'

    import BookingSummary from '../components/bookings/BookingSummary'
    import TripDetails from "../components/bookings/TripDetails";
    import EditBooking from "../components/bookings/EditBooking";
    import CompareBooking from "../components/bookings/CompareBooking";
    import ConfirmDialog from '../components/ConfirmDialog.vue'

    import {datesMixin} from "../mixins/DatesMixin"

    const LIST_MODE_ALL = 0, LIST_MODE_FUTURE = 1;

    export default {
        name: "ListBookings.vue",
        components: { BookingSummary, TripDetails, EditBooking, CompareBooking, ConfirmDialog, Spinner },
        mixins: [datesMixin],
        data: function () {
            return {
                listMode: LIST_MODE_FUTURE,
                bookings: [],
                localBooking: null,
                remoteBooking: null,
                showCancelledBookings: false,
                loading: true,
                updating: false,
                allPageNumber: 0,
                allPageSize: 20,
                allBookingsLoaded: false,
                from: "",
                to: "",
                showEditBooking: false,
                showTripDetails: false,
                showCompareBookingDialog: false,
                showConfirmDeleteDialog: false,
                showConfirmMigrateDialog: false,
                showConfirmAcceptOrRejectChangesDialog: false,
                showConfirmManuallyUpdateDialog: false,
                trip: null,
                error: false,
                infoMessage: ""
            }
        },
        computed: {
            isPMSEstablishment: function() {
                if (getters.getCurrentEstablishment().provider) {
                    return true;
                }
                return false;
            },
            isListAllBookings: function() {
                return this.listMode === LIST_MODE_ALL;
            },
            isListFutureBookings: function() {
                return this.listMode === LIST_MODE_FUTURE;
            },
            bookingsToShow: function() {
                let bookings = [];
                for (const booking of this.bookings) {
                    if (this.showCancelledBookings || booking.state !== 'cancelled') {
                        bookings.push(booking);
                    }
                }
                return bookings;
            },
            hasBookings: function() {
                return this.bookings !== null && this.bookings.length > 0;
            },
            canLoadMoreBookings: function () {
                if (this.isListAllBookings && !this.allBookingsLoaded) {
                    return true;
                }
                return false;
            },
            confirmDeleteMessage: function() {
                return "Are you sure you want to <b>cancel the booking for " + this.trip.bookedBy.firstName + " " + this.trip.bookedBy.lastName + "?</b>";
            },
            confirmMigrateMessage: function() {
                return "Are you sure you want to <b>migrate the booking for " + this.trip.bookedBy.firstName + " " + this.trip.bookedBy.lastName + "?</b>";
            },
            confirmAmendMessage: function() {
                return "<b>" + this.trip.bookedBy.firstName + " " + this.trip.bookedBy.lastName +
                        " has requested an amendment.</b> We have sent you an email with the details of the " +
                        "changes." +
                        "<br/><br/>Select <b>Accept</b> if you can accommodate the request, or <b>Reject</b> otherwise." +
                        "<br/><br/>(NOTE: if you accept the request, you still need to update the booking in your PMS)";
            },
            confirmManuallyUpdateMessage: function() {
                return "This booking for <b>" + this.trip.bookedBy.firstName + " " + this.trip.bookedBy.lastName +
                        "</b> has been changed locally and differs from the version stored on your PMS.<br/><br/> " +
                        "To re-activate this booking, <b>review the differences and merge</b> the booking";
                // return "Are you sure you want to <b>keep the changes to the booking for " +
                //     this.trip.bookedBy.firstName + " " + this.trip.bookedBy.lastName +
                //     "</b> as shown here? (and ignore changes from the PMS)";
            },
        },
        methods: {
            listAll: function() {
                this.listMode = LIST_MODE_ALL;
                this.allPageNumber = 0;
                this.allPageSize = 20;
                this.allBookingsLoaded = false;
                this.bookings.splice(0, this.bookings.length);
                this.fetchAndLoadBookings();
            },
            loadMoreBookings: function() {
                this.allPageNumber++;
                this.fetchAndLoadBookings();
            },
            fetchAndLoadBookings: function() {
                this.fetchBookings((pageOfBookings) => {
                    console.log(pageOfBookings);
                    if (pageOfBookings.numberOfElements > 0) {
                        this.bookings.push(...pageOfBookings.content);
                    }
                    if (pageOfBookings.numberOfElements < this.allPageSize) {
                        this.allBookingsLoaded = true;
                    }
                })
            },
            fetchBookings: function (callback) {
                this.loading = true;
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings', {
                    params: {pageNumber: this.allPageNumber, pageSize: this.allPageSize},
                    withCredentials: true
                }).then(response => {
                    callback(response.data);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                })
            },
            listFuture: function() {
                this.listMode = LIST_MODE_FUTURE;
                this.from = dayjs().format('YYYY-MM-DD');
                this.to = null;
                this.bookings.splice(0, this.bookings.length);
                this.fetchFirstPageOfFutureBookings();
            },
            loadMoreFutureBookings: function() {
                const fromDate = this.to;
                const toDate = dayjs(this.to).add(30, "day").format('YYYY-MM-DD');
                this.to = toDate;
                this.fetchFutureBookings(fromDate, toDate, (bookings) => {
                    console.log(bookings);
                    this.bookings.push(...bookings);
                })
            },
            fetchFutureBookings: function (from, to, callback) {
                this.loading = true;
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/arrival/from/' + from, {
                    withCredentials: true
                }).then(response => {
                    callback(response.data);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                })
            },
            fetchFirstPageOfFutureBookings: function() {
                this.fetchFutureBookings(this.from, this.to, (bookings) => {
                    console.log(bookings)
                    this.bookings.push(...bookings);
                })
            },
            moreBookings: function () {
                console.log("fetching more bookings");
                if (this.isListAllBookings) {
                    this.loadMoreBookings();
                } else {
                    this.loadMoreFutureBookings();
                }
            },
            toggleShowCancelledBookings: function(toggle) {
                this.showCancelledBookings = toggle;
            },
            addBooking: function () {
                this.trip = {
                    dateBooked: dayjs().toISOString(),
                    arrival: dayjs().format('YYYY-MM-DD'),
                    departure: dayjs().add(2, "day").format('YYYY-MM-DD'),
                    channel: {
                        providerChannelId: "unknown"
                    },
                    bookedBy: {
                        firstName: '',
                        lastName: '',
                        email: ''
                    },
                    rooms: [
                        {
                            roomTypeName: "Standard",
                            numberOfAdults: 2,
                            numberOfChildren1: 0,
                            roomRate: ""
                        }
                    ]
                };
                this.showEditBooking = true;
            },
            addBookingToList: function(booking) {
                this.bookings.push(booking);
            },
            updateBookingInList: function(booking) {
                for (let i = 0; i < this.bookings.length; i++) {
                    if (this.bookings[i].reference === booking.reference) {
                        Vue.set(this.bookings, i, booking);
                        return;
                    }
                }
            },
            editBooking: function (booking) {
                this.trip = booking;
                this.showEditBooking = true;
            },
            confirmDeleteAction: function(booking) {
                this.trip = booking;
                this.showConfirmDeleteDialog = true;
            },
            cancelBooking: function (reference) {
                for (let booking of this.bookings) {
                    this.showConfirmDeleteDialog = false;
                    if (booking.reference === reference) {
                        console.log("cancel booking: " + booking.reference);
                        this.infoMessage = "Cancelling booking";
                        this.updating = true;
                        this.$http.delete('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                            + '/bookings/' + booking.reference
                        ).then(response => {
                            console.log("Booking cancelled:")
                            console.log(response);
                            this.infoMessage = "Booking cancelled";
                            setTimeout(() => {
                                for (let i = 0; i < this.bookings.length; i++) {
                                    if (this.bookings[i].reference === booking.reference) {
                                        this.bookings[i].state = 'cancelled';
                                        break;
                                    }
                                }
                                this.updating = false;
                            }, 2000);
                        }).catch(error => {
                            this.updating = false;
                            this.error = true;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message;
                            } else {
                                this.infoMessage = "Error cancelling booking";
                            }
                            setTimeout(() => {
                                this.error = false;
                            }, 5000);
                        });
                    }
                }
            },
            confirmMigrateAction: function(booking) {
                this.trip = booking;
                this.showConfirmMigrateDialog = true;
            },
            migrateBooking: function(reference) {
                for (let booking of this.bookings) {
                    this.showConfirmMigrateDialog = false;
                    if (booking.reference === reference) {
                        console.log("migrate booking: " + booking.reference);
                        this.infoMessage = "Migrating booking";
                        this.updating = true;
                        this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                            + '/bookings/' + booking.reference + "/migrate"
                        ).then(response => {
                            console.log("Booking migrated:")
                            console.log(response);
                            this.infoMessage = "Booking migrated";
                            setTimeout(() => {
                                for (let i = 0; i < this.bookings.length; i++) {
                                    if (this.bookings[i].reference === booking.reference) {
                                        this.bookings[i].state = 'active';
                                        break;
                                    }
                                }
                                this.updating = false;
                            }, 2000);
                        }).catch(error => {
                            this.updating = false;
                            this.error = true;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message;
                            } else {
                                this.infoMessage = "Error migrating booking";
                            }
                            setTimeout(() => {
                                this.error = false;
                            }, 5000);
                        });
                    }
                }
            },
            confirmAmendAction: function(booking) {
                this.trip = booking;
                this.showConfirmAcceptOrRejectChangesDialog = true;
            },
            confirmManuallyUpdateAction: function(booking) {
                this.trip = booking;
                this.showConfirmManuallyUpdateDialog = true;
            },
            rejectChangesToBooking: function(reference) {
                this.showConfirmAcceptOrRejectChangesDialog = false;
                if (reference) {
                    for (let booking of this.bookings) {
                        if (booking.reference === reference) {
                            console.log("rejecting changes to booking: " + booking.reference);
                            this.infoMessage = "Rejecting changes to booking";
                            this.updating = true;
                            this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                                    + '/bookings/' + booking.reference + "/manually-reject-changes"
                            ).then(response => {
                                console.log("Booking changes rejected:")
                                console.log(response);
                                this.infoMessage = "Changes rejected and booking reverted";
                                setTimeout(() => {
                                    for (let i = 0; i < this.bookings.length; i++) {
                                        if (this.bookings[i].reference === booking.reference) {
                                            this.bookings[i].state = response.data.state;
                                            break;
                                        }
                                    }
                                    this.updating = false;
                                }, 2000);
                            }).catch(error => {
                                this.updating = false;
                                this.error = true;
                                if (error.response) {
                                    this.infoMessage = "Error: " + error.response.data.message;
                                } else {
                                    this.infoMessage = "Error rejecting booking changes";
                                }
                                setTimeout(() => {
                                    this.error = false;
                                }, 5000);
                            });
                        }
                    }
                }
            },
            compareWithPMS: function (reference) {
                this.showConfirmAcceptOrRejectChangesDialog = false;
                this.showConfirmManuallyUpdateDialog = false;
                if (reference) {
                    for (let booking of this.bookings) {
                        if (booking.reference === reference) {
                            this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/' + booking.reference + "/compare-with-pms"
                            ).then(response => {
                                this.localBooking = response.data.local;
                                this.remoteBooking = response.data.remote;
                                this.showCompareBookingDialog = true;
                            }).catch(error => {
                                this.error = true;
                                if (error.response) {
                                    this.infoMessage = "Error: " + error.response.data.message;
                                } else {
                                    this.infoMessage = "Error fetching copies of booking";
                                }
                                setTimeout(() => {
                                    this.error = false;
                                }, 5000);
                            })
                        }
                    }
                }
            },
            hideCompareDialog: function() {
                this.showCompareBookingDialog = false;
            },
            manuallyAcceptChangesToBooking: function(reference) {
                this.hideCompareDialog();
                this.showConfirmAcceptOrRejectChangesDialog = false;
                this.showConfirmManuallyUpdateDialog = false;
                if (reference) {
                    for (let booking of this.bookings) {
                        if (booking.reference === reference) {
                            console.log("manually accepting changes to booking: " + booking.reference);
                            this.infoMessage = "Manually accepting changes to booking";
                            this.updating = true;
                            this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                                    + '/bookings/' + booking.reference + "/manually-accept-changes"
                            ).then(response => {
                                console.log("Booking changes manually accepted:")
                                console.log(response);
                                this.infoMessage = "Changes to booking manually accepted";
                                setTimeout(() => {
                                    for (let i = 0; i < this.bookings.length; i++) {
                                        if (this.bookings[i].reference === booking.reference) {
                                            this.bookings[i].state = response.data.state;
                                            break;
                                        }
                                    }
                                    this.updating = false;
                                }, 2000);
                            }).catch(error => {
                                this.updating = false;
                                this.error = true;
                                if (error.response) {
                                    this.infoMessage = "Error: " + error.response.data.message;
                                } else {
                                    this.infoMessage = "Error manually accepting changes to booking";
                                }
                                setTimeout(() => {
                                    this.error = false;
                                }, 5000);
                            });
                        }
                    }
                }
            },
            hideAddBooking: function () {
                this.showEditBooking = false;
                this.trip = null;
            },
            showTrip: function(booking) {
                this.trip = booking;
                this.showTripDetails = true;
            },
            hideTrip: function () {
                this.showTripDetails = false;
                this.trip = null;
            }
        },
        mounted() {
            console.log("Loading bookings");
            this.listFuture();
            this.$root.$on('selected-establishment', this.listFuture);
            this.$root.$on('show-trip', this.showTrip);
            this.$root.$on('edit-booking', this.editBooking);
            this.$root.$on('confirm-delete-booking', this.confirmDeleteAction);
            this.$root.$on('confirm-migrate-booking', this.confirmMigrateAction);
            this.$root.$on('confirm-amend-booking', this.confirmAmendAction);
            this.$root.$on('confirm-manually-update-booking', this.confirmManuallyUpdateAction);
            this.$root.$on('finished-editing-booking', this.hideAddBooking);
            this.$root.$on('booking-added', this.addBookingToList);
            this.$root.$on('booking-updated', this.updateBookingInList);
            this.$root.$on('delete-booking', this.cancelBooking);
            this.$root.$on('migrate-booking', this.migrateBooking);
            this.$root.$on('reject-booking-changes', this.rejectChangesToBooking);
            this.$root.$on('review-booking', this.compareWithPMS);
            this.$root.$on('cancel-comparing-bookings', this.hideCompareDialog);
            this.$root.$on('manually-update-booking', this.manuallyAcceptChangesToBooking);
            this.$root.$on('finished-viewing-trip-details', this.hideTrip);
        },
        beforeDestroy () {
            this.$root.$off('selected-establishment', this.listFuture);
            this.$root.$off('show-trip', this.showTrip);
            this.$root.$off('edit-booking', this.editBooking);
            this.$root.$off('confirm-delete-booking', this.confirmDeleteAction);
            this.$root.$off('confirm-migrate-booking', this.confirmMigrateAction);
            this.$root.$off('confirm-amend-booking', this.confirmAmendAction);
            this.$root.$off('confirm-manually-update-booking', this.confirmManuallyUpdateAction);
            this.$root.$off('finished-editing-booking', this.hideAddBooking);
            this.$root.$off('booking-added', this.addBookingToList);
            this.$root.$off('booking-updated', this.updateBookingInList);
            this.$root.$off('delete-booking', this.cancelBooking);
            this.$root.$off('migrate-booking', this.migrateBooking);
            this.$root.$off('reject-booking-changes', this.rejectChangesToBooking);
            this.$root.$off('review-booking', this.compareWithPMS);
            this.$root.$off('cancel-comparing-bookings', this.hideCompareDialog);
            this.$root.$off('manually-update-booking', this.manuallyAcceptChangesToBooking);
            this.$root.$off('finished-viewing-trip-details', this.hideTrip);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/pills";
    @import "../styles/layout/filter";
    @import "../styles/pages/list-forms";
    @import "../styles/pages/list-bookings";
</style>